import { Navigation } from "../components/Navigation";
import { Projects } from "../components/Projects";
import { Footer } from "../components/Footer";
import { useEffect } from "react";

export function ProjectsPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 font-sans text-zinc-900">
      <Navigation />
      <main className="pt-20">
        <Projects isFullPage={true} />
      </main>
      <Footer />
    </div>
  );
}
